<template>
	<div class="no-auth">
		<div v-if="isAuth">
			<slot></slot>
		</div>
		<el-card v-else>
			<div class="content">
				<div class="left">
					<img src="https://cdn.dkycn.cn/melyshop/image/20210802-c8b01cda-ac9f-464c-ab7c-73bb1d848b9d.png">
					<div class="info">
						<div class="tit">批量加好友</div>
						<div class="tip">批量导入潜在客户手机号，自动给员工发送添加任务提醒，并实时跟进员工添加情况。若员工长时间未与客户添加，系统支持自动回收重新分配。</div>
					</div>
				</div>
				<div class="right">
					<el-button type="primary" @click="handleUse">授权安装企店助手</el-button>
				</div>
			</div>
			<div style="margin-top:25px">
				<div class="desc-title">1/导入客户</div>
				<img style="display: block;width:100%;max-width: 885px;" src="https://cdn.dkycn.cn/melyshop/image/20210802-13662419-5c85-4955-a578-6d6646664246.png"></img>
				<div class="desc-title">2/添加客户</div>
				<img style="display: block;width:100%;max-width: 885px;" src="https://cdn.dkycn.cn/melyshop/image/20210802-5c51b328-34a6-4744-bf9a-74e92ab4015a.png"></img>
				<div class="desc-title">3/任务追踪</div>
				<img style="display: block;width:100%;max-width: 885px;" src="https://cdn.dkycn.cn/melyshop/image/20210802-f3548054-2db1-4616-b627-147a015f1130.png"></img>
			</div>
		</el-card>
	</div>
</template>

<script>
	import {
		qyweixinsuiteauthinfo
	} from "@/api/sv1.0.0";
	import config from "@/config/index";

	export default {
		components: {},
		data() {
			return {
				isAuth: true,
				goUrls: config.GO_URL,
			};
		},
		beforeMount() {
			this.getData();
		},
		methods: {
			async getData(callback) {
				try {
					const res = await qyweixinsuiteauthinfo();
					this.isAuth = res.Result.IsFinishQyWeixinSuiteStp;
				} catch (e) {
				}
			},
			handleUse() {
				// let headsUrls = process.env.NODE_ENV == 'production' ? 'index.html#' : ''
				// let url = this.goUrls + headsUrls + '/saleChannel/qyWechat'
				// window.open(url)
				this.$router.push({
					path: '/saleChannel/qyWechat'
				})
			}
		}
	}
</script>

<style lang="less" scoped>
	.content {
		display: flex;
		overflow: hidden;
		padding: 15px;
		background-color: #f8f8f9;
	
		.left {
			flex: 1 1 auto;
			overflow: hidden;
			margin-right: 20px;
			display: flex;
	
			img {
				flex: 0 0 auto;
				width: 46px;
				height: 46px;
			}
	
			.info {
				flex: 1 1 auto;
				overflow: hidden;
				margin-left: 10px;
				padding-top: 2px;
	
				.tit {
					font-size: 14px;
					font-weight: bold;
				}
	
				.tip {
					font-size: 12px;
					color: #999;
					margin-top: 10px;
				}
			}
		}
	
		.right {
			flex: 0 0 auto;
		}
	}
	
	.desc-title{
		font-weight: bold;
		margin-top: 30px;
		font-size: 16px;
		margin-bottom: 10px;
	}
</style>
